// @flow

import {useUsercentricsConsent} from 'redux/middleware/usercentrics';

import {createContext} from 'react';

export const ConsentContext = createContext(null);

export const ConsentProvider = ({children}) => {
  const contextValue = useUsercentricsConsent();

  return (
    <ConsentContext.Provider value={contextValue}>
      {children}
    </ConsentContext.Provider>
  );
}
